import { createCFFTextAttr, createCFF, ContextFormField } from '@components/context-form-field';
import { ScrollSectionTitle } from '@components/scroll-section-title';
import { Divider, Grid, GridSize, Typography } from '@material-ui/core';
import { indigo } from '@material-ui/core/colors';
import BallotRoundedIcon from '@material-ui/icons/BallotRounded';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { DatePicker } from '@material-ui/pickers';
import { createControlField } from '@lib/common';

const AirDateField = createControlField(props => (
  <DatePicker
    fullWidth
    style={{ marginTop: 0, marginBottom: 0 }}
    inputVariant="outlined"
    views={['year', 'month', 'date']}
    format={"MMM d, yyyy"}
    margin="normal"
    size="small"
    {...props}
  />
));

export const OtherAttributesSection = ({isASeriesContent=false}) => {
    const { control } = useFormContext();
    const attributes = [
      createCFFTextAttr('revenue', 'Revenue', 'Revenue earned in USD$'),
      createCFFTextAttr('popularity', 'Popularity', 'Popularity Score'),
      createCFFTextAttr('vote_average', 'Rating', 'Content Rating'),
      createCFFTextAttr('tagline', 'Tagline', 'Tagline of the project'),
      createCFFTextAttr('wikidata_id', 'Wikidata', 'Content URL in Wikidata'),
      createCFFTextAttr('facebook_url', 'Facebook', "Content URL in Facebook"),
      createCFFTextAttr('instagram_url', 'Instagram', "Content URL in Instagram"),
      createCFFTextAttr('twitter_url', 'Twitter', "Content URL in X/Twitter"),
      createCFFTextAttr('freebase_id', 'Freebase', 'Content ID in Freebase'),
      createCFFTextAttr('tvdb_id', 'TVBD', 'Content ID in TVBD'),
    ];
    return (
      <>
        <ScrollSectionTitle
          id="other-attributes"
          subTitle="Basic, essential details of the content, used in summaries."
          icon={<BallotRoundedIcon style={{ color: indigo[700] }} fontSize="large" />}>
          Other Attributes
        </ScrollSectionTitle>
        <Divider />
        <br />
        <Grid container spacing={4}>
          <Grid item xs>
            <Grid container xs={12} spacing={1}>
              {attributes.map((attr, idx) => (
                <Grid key={idx} item xs={4}>
                  <ContextFormField {...attr} />
                </Grid>
              ))}
              <Grid item xs={4}>
                  <AirDateField  control={control} name="first_air_date" label="First Air Date" helperText="Date on which the content aired the first time"/>
              </Grid>
              {isASeriesContent && <Grid item xs={4}>
                  <AirDateField  control={control} name="last_air_date" label="Last Air Date" helperText="Date at which the Last episode aired."/>
              </Grid>}
            </Grid>
            <br/>
            <br/>
          </Grid>
        </Grid>
      </>
    );
  };
  